import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
  OnDestroy,
  ElementRef
} from '@angular/core';
import { ControlType, SearchControl } from 'bpt-ui-library/bpt-search';
import { Observable, forkJoin, of, Subscription } from 'rxjs';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { ChangeRegisterConstants } from '../change-register-constants';
import { ChangeRegisterService } from '../services/change-register.service';
import { ChangeControlService } from '../../change-control/change-control-library/services/changecontrol.service';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { UsersService } from '../../shared/services/users.service';
import { ChangeControlSearch } from '../models/change-control-search';
import { ChangeControlSearchResult } from '../models/change-control-search-result';
import { ChangeControlQueryResult } from '../../change-control-catalogue/models/change-control-query-result';
import { PanelHubComponent } from '../../shared-components/panel-hub/panel-hub.component';
import { PanelHubConfiguration } from '../../shared-components/panel-hub/models/panel-hub-configuration';
import { PanelHubConstants } from '../../shared-components/panel-hub/constants/panel-hub-constants';
import { Features } from '../../shared-components/panel-hub/enums/features.enum';
import { PaginationConfigByFeature } from '../../shared-components/panel-hub/constants/feature-pagination-configuration';
import { FilterConfig } from '../../shared-components/panel-hub/models/filter-config';
import { SortField } from '../../shared-components/panel-hub/models/sort-field';
import { PanelHubEventType } from '../../shared-components/panel-hub/enums/panel-hub-eventtype';
import { PanelHubStateChangedEvent } from '../../shared-components/panel-hub/models/panel-hub-state-changed-event';
import { PanelEventHub } from '../../shared-components/panel-hub/models/panel-event-hub';
import { AppliedFilters } from '../../shared-components/panel-hub/models/applied-filters';
import { PaginationState } from '../../shared-components/panel-hub/models/pagination-state';
import { SortCriteria } from '../../shared-components/panel-hub/models/sort-criteria';

import { ChangeRegisterPeristenceService } from '../services/change-register-peristence.service';
import { DateTimePickerService } from '../../shared/utils/date-time-picker.util.service';
import { PanelCardView } from '../../shared/enums/panelCardView';

@Component({
  selector: 'app-change-control-search',
  templateUrl: './change-control-search.component.html',
  styleUrls: ['./change-control-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe]
})


export class ChangeControlSearchComponent
  implements OnInit, AfterViewInit, OnDestroy {


  @Input() feature: string = ChangeRegisterConstants.ChangeControl_Feature;
  @Input() enableCheckBoxes = false;

  @Output() emitSelectedData = new EventEmitter<any>();
  @Output() shouldAddTrainingItemAsCourseButtonDisplayed =
    new EventEmitter<boolean>();
    
@ViewChild('panelHub', { read: ElementRef })
private panelHubEl!: ElementRef;

  placeHolder: string =
    ChangeRegisterConstants.ChangeControlSearch_Place_Holder_Text;

  spinnerOn = false;
  isSearch = false;
  hasUserSearched = false;

  noData = false;
  isPanelHubDataAvailable = false;
  currentView: number = 0; // default view
  
  
  changeControlSearchResult: ChangeControlSearchResult[] = [];

combinedSearchCriteria: any = {};
panelFilters: { [key: string]: any } = {};

  panelCardViewType: number = PanelCardView.DefaultView;
  defaultView = PanelCardView.DefaultView;
  assignmentView = PanelCardView.AssignmentView;

  errorText: string = '';
showLoader: boolean = false;
assignmentGroups: { label: string; data: any[] }[] = [];


isScopeMasterDataLoaded = false;
isSbuMasterDataLoaded = false;
isUsersMasterDataLoaded = false;


  searchControl: SearchControl[] = [];
  filterData: any[] = [];
  changeControlSearchData: ChangeControlSearch = new ChangeControlSearch();


  lookupData: any;
  scopeList: any[] = [];
  sbuList: any[] = [];
  userList: any[] = [];


  @ViewChild(PanelHubComponent)
  private panelHub!: PanelHubComponent;

  panelEventHub!: PanelEventHub;
  panelListViewSubscription!: Subscription;

  panelHubConfig: PanelHubConfiguration = {
    title: '',
    feature: Features.ChangeRegisterView,
    standardFilterCount: PanelHubConstants.StandardFilterLength,
    showSelectAll: false,
    enableShowAllToggle: false,
    enableSelectAll: false,
    enableSelection: this.enableCheckBoxes,
    enableToggling: true,
    enablePanelCardClick: false,
    enablePanelHighLight: false,
    enablePanelCardView: true,
    enableExpandCollapse: true,
    enableViewModes: true,
    enableAssignmentView: true,
    enableWhereAmIUsedView: false,
    paginationConfig:
      PaginationConfigByFeature[Features.ChangeRegisterView]
  };

  pagedData: ChangeControlQueryResult = {
    totalRecords: 0,
    data: [],
    pageNumber: 1,
    pageSize: 0
  };

  currentFilters: AppliedFilters | null = null;
  currentPagination: PaginationState | null = null;
  currentSort: SortCriteria | null = null;


  baseFilters: AppliedFilters | null = null;
  primarySearchText: string | null = null;
  secondarySearchText: string | null = null;
  preserveSearchData: boolean = false;

  constructor(
    private changeRegisterService: ChangeRegisterService,
    private changeControlService: ChangeControlService,
    private eqmsScopeService: EqmsScopeManagementService,
    private usersService: UsersService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private persistence: ChangeRegisterPeristenceService,
    private datePickerService: DateTimePickerService
  ) {}

  ngOnInit(): void {
    this.initialize();
    this.subscribeToViewChanges();

    this.currentPagination = {
      pageNumber: 1,
      pageSize:
        this.panelHubConfig.paginationConfig.defaultPageSize,
      totalRecords: 0
    };
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.panelListViewSubscription?.unsubscribe();
  }

  private initialize() {
  this.spinnerOn = true;

  forkJoin({
    lookup: this.changeControlService.getChangeControlLookUpDetails(),
    scopes: this.changeRegisterService.geteQMSScopesForChangeControlSearch(),
    subBus: this.changeRegisterService.getsubBuMasterData(),
    users: this.usersService.getUsers()
  })
    .pipe(finalize(() => (this.spinnerOn = false)))
    .subscribe(res => {
      this.lookupData = res.lookup;

      // Scope master data
      this.scopeList = res.scopes.map((s: any) => ({
        name: s.eQMSScopeName,
        value: s.eQMSScopeId
      }));
      this.isScopeMasterDataLoaded = true;

      // Sub-BU master data
      this.sbuList = res.subBus.map((s: any) => ({
        name: s.name,
        value: s.value
      }));
      this.isSbuMasterDataLoaded = true;

      // User master data
      this.userList = res.users.map((u: any) => ({
        name: u.name,
        value: u.name
      }));
      this.isUsersMasterDataLoaded = true;

      // Build search controls
      this.buildSearchControls();

      // Initialize panel hub or other view configs
      this.updatePanelHubConfigForCurrentView();
    });
}



  private subscribeToViewChanges() {
    this.panelListViewSubscription =
      this.persistence.panelListView$.subscribe(view => {
        this.panelCardViewType = view;
        this.updatePanelHubConfigForCurrentView();
      });
  }

  /* Search Controls */

  private buildSearchControls() {
  this.searchControl = [
    {
      controlType: ControlType.List,
      label: 'eQMS Scope(s)',
      fieldName: 'eQMSScope',
      multiSelect: true,
      options: this.scopeList,
      value: undefined,
      labelField: 'name',
      valueField: 'value',
      showFilter: true,
      order: 1
    },
    {
      controlType: ControlType.Datepicker,
      label: 'Target Completion Date',
      fieldName: 'targetCompletionDate',
      enableRange: true,
      value: [],
      order: 2
    },
    {
      controlType: ControlType.List,
      label: 'Responsible Sub-BU',
      fieldName: 'responsibleSubBU',
      multiSelect: true,
      options: this.sbuList,
      value: undefined,
      labelField: 'name',
      valueField: 'value',
      showFilter: true,
      order: 3
    },
    {
      controlType: ControlType.List,
      label: 'Phase(s)',
      fieldName: 'phases',
      multiSelect: true,
      options: this.lookupData?.phases || [],
      value: [0],
      labelField: 'name',
      valueField: 'value',
      showFilter: true,
      order: 4
    },
    {
      controlType: ControlType.List,
      label: 'Category',
      fieldName: 'category',
      multiSelect: true,
      options: this.lookupData?.categories || [],
      value: undefined,
      labelField: 'name',
      valueField: 'value',
      showFilter: true,
      order: 5
    },
    {
      controlType: ControlType.List,
      label: 'User',
      fieldName: 'user',
      multiSelect: true,
      options: this.userList,
      value: undefined,
      labelField: 'name',
      valueField: 'value',
      showFilter: true,
      order: 6
    }
  ];
}



getSearchResults = (searchText: string): Observable<number> => {
  this.resetPanelHubState();
  this.panelFilters = {};
this.currentFilters = null;
  this.resetChangeControlSearchData(false, true);
  this.changeControlSearchData.categories = [];
  this.changeControlSearchData.phases = [];
  this.changeControlSearchData.eQMSScopes = [];
  this.changeControlSearchData.responsibleSubBUs = [];
  this.changeControlSearchData.targetCompletionDates = [];
  this.changeControlSearchData.users = [];

  this.primarySearchText = searchText ?? null;
  this.changeControlSearchData.searchText =
    this.primarySearchText ?? undefined;
  this.baseFilters = null;
  this.hasUserSearched = true;
  this.updatePanelHubConfigForCurrentView();
  return of(this.performChangeControlSearch());
};



getAdvancedSearchResults = (
  filters: Array<any>,
  searchText: string
): Observable<number> => {

  this.resetPanelHubState(); 

  this.resetChangeControlSearchData(false, this.preserveSearchData);
  this.isSearch = true;

  this.primarySearchText = searchText ?? null;

 this.changeControlSearchData.searchText =
  this.primarySearchText ?? this.changeControlSearchData.searchText;


  if (this.currentPagination) {
    this.currentPagination.pageNumber = 1;
  }

  this.buildBaseFilters(filters);

  filters.forEach(filter => {
    switch (filter.columnName) {
      case 'category':
        this.changeControlSearchData.categories = filter.values?.map(String);
        break;
      case 'phases':
        this.changeControlSearchData.phases = filter.values?.map(String);
        break;
      case 'eQMSScope':
        this.changeControlSearchData.eQMSScopes = filter.values;
        break;
      case 'responsibleSubBU':
        this.changeControlSearchData.responsibleSubBUs =
          filter.values?.map(String);
        break;
      case 'targetCompletionDate': {
        if (!filter.values || filter.values.length === 0) {
          break;
        }
        const targetCompletionDateRange = this.datePickerService.toUtcRange(filter.values);
        this.changeControlSearchData.targetCompletionDates = [targetCompletionDateRange.start, targetCompletionDateRange.end];
        break;
      }
      case 'user':
        this.changeControlSearchData.users = filter.values;
        break;
    }
  });

  if (this.areAllValuesNullOrUndefined(this.changeControlSearchData)) {
    this.messageService.add({
      severity: ChangeRegisterConstants.Severity_Info,
      summary: ChangeRegisterConstants.ChangeControlSearchEmpty_Filters
    });
    return of(0);
  }

  this.hasUserSearched = true;
  this.updatePanelHubConfigForCurrentView();

  return of(this.performChangeControlSearch());
};



private buildPayloadFilter(
  baseFilters: AppliedFilters | null,
  panelHubFilters: AppliedFilters | null
): any {

  const merged = this.mergeFilters(baseFilters, panelHubFilters);
  const panelSearchText = panelHubFilters?.searchText;

  return {
    SearchText:
      typeof panelSearchText === 'string' && panelSearchText.trim().length > 0
        ? panelSearchText
        : null,

    FilterItems: merged?.filters?.map(f => ({
      Field: this.mapFilterFields(f.field),
      Values: (f.values || []).map(String)
    })) || []
  };
}

private resetPanelHubState(): void {
  if (this.panelEventHub?.resetConfigurations) {
    this.panelEventHub.resetConfigurations();
  }
  this.currentFilters = null;
  this.currentSort = null;
  if (this.currentPagination) {
    this.currentPagination.pageNumber = 1;
  }
  }

private mapFilterFields(field: string): string {
  const map: { [key: string]: string } = {
    phases: 'phaseName',
    categoryName: 'categoryName',
    priorityName:'priorityName',
    eQMSScopes: 'eQMSScopeDisplayNames',
    responsibleSubBUs: 'responsibleSubBU',
    collaborators: 'collaborators',
    reviewers: 'reviewers',
    approvers: 'approvers',
    verifiers: 'verifiers',
    internalClientContact: 'internalClientContact'
  };
  return map[field] || field;
}

onPanelFilterChanged(filterKey: string, filterValue: any) {
  this.panelFilters[filterKey] = filterValue;
  const control = this.searchControl.find(c => c.fieldName === filterKey);
  if (control) {
    control.value = filterValue;
  }

  const searchText = this.primarySearchText || '';
  this.preserveSearchData = true;
  this.getAdvancedSearchResults([], searchText).subscribe();
}


resetChangeControlSearchData(clearPanelFilters = true, preserveSearchData = true) {
  if (!preserveSearchData) {
    this.changeControlSearchData = {};
    this.hasUserSearched = false;
  } else {
    if (!this.changeControlSearchData) {
      this.changeControlSearchData = {};
    }
  }

  if (clearPanelFilters) {
    this.panelFilters = {};
  }
}


private buildBaseFiltersFromAdvancedSearch(): AppliedFilters | null {
  const filters: any[] = [];

  if (this.changeControlSearchData.phases?.length) {
    filters.push({
      field: 'phaseName',
      values: this.changeControlSearchData.phases.map(String)
    });
  }

  if (this.changeControlSearchData.categories?.length) {
    filters.push({
      field: 'categoryName',
      values: this.changeControlSearchData.categories.map(String)
    });
  }

  if (this.changeControlSearchData.eQMSScopes?.length) {
    filters.push({
      field: 'eQMSScopeDisplayNames',
      values: this.changeControlSearchData.eQMSScopes
    });
  }

  if (this.changeControlSearchData.responsibleSubBUs?.length) {
    filters.push({
      field: 'responsibleSubBU',
      values: this.changeControlSearchData.responsibleSubBUs
    });
  }

  if (this.changeControlSearchData.users?.length) {
    filters.push({
      field: 'user',
      values: this.changeControlSearchData.users
    });
  }

  if (!filters.length && !this.changeControlSearchData.searchText) {
    return null;
  }

  return {
    filters,
    searchText: this.changeControlSearchData.searchText || undefined
  };
}



  /* Main search  */

  private performChangeControlSearch(): number {

    if (!this.currentPagination) {
      this.currentPagination = {
        pageNumber: 1,
        pageSize: 25,
        totalRecords: 0
      };
    }

   const payload = {
  ...this.changeControlSearchData,
  Filter: this.buildPayloadFilter(this.baseFilters, this.currentFilters),
  Sort: this.buildSortPayload(this.currentSort),
  Pagination: {
    PageNumber: this.currentPagination.pageNumber,
    PageSize: this.currentPagination.pageSize
  }
};

    this.spinnerOn = true;

    this.changeRegisterService
      .getchangeControlSearch(payload)
      .pipe(
        switchMap(result =>
          this.updateeQMSScopeData(result.data).pipe(
            map(data => ({
              data,
              totalRecords: result.totalRecords
            }))
          )
        ),
        catchError(() => of({ data: [], totalRecords: 0 })),
        finalize(() => (this.spinnerOn = false))
      )
      .subscribe(res => {
        this.updateSearchResult(res.data, res.totalRecords);
        this.preserveSearchData = false;
      });

    this.isSearch = true;
    return 0;
  }

  private refreshPanelHubData() {
    this.performChangeControlSearch();
  }

  private buildSortPayload(sort: SortCriteria | null) {
    if (!sort || !sort.field) return null;

    return {
      Fields: [
        {
          field: this.mapSortField(sort.field),
          sortDirection: sort.sortDirection
        }
      ]
    };
  }

  private mapSortField(field: string): string {
    const map: { [key: string]: string } = {
      categoryName: 'category',
      phaseName: 'phase',
      priorityName:'priority',
      responsibleSubBU: 'responsibleSubBU',
      eQMSScopeDisplayNames: 'scopeName',
      implementationOwnersInformation: 'implementationOwner',
      collaborators: 'collaboratorsInformation',
      reviewers: 'reviewersInformation',
      approvers: 'approversInformation',
      verifiers: 'verifiersInformation',
      internalClientContacts: 'internalClientContactInformation'
    }

    return map[field] || field;
  }


  /* Panel Hub event triggers */

 onPanelHubInitialized(event: any) {
    this.panelEventHub = event;
  }

  onPanelHubStateChanged(event: PanelHubStateChangedEvent) {
    if (!this.hasUserSearched) return;

     if (this.primarySearchText) {
    this.changeControlSearchData.searchText = this.primarySearchText;
  }

    switch (event.type) {
      case PanelHubEventType.FilterChanged:
        this.currentFilters = event.state.filters || null;
        if (this.currentPagination) this.currentPagination.pageNumber = 1;
        this.refreshPanelHubData();
        break;

      case PanelHubEventType.SortChanged:
        this.currentSort = event.state.sort || null;
        if (this.currentPagination) this.currentPagination.pageNumber = 1;
        this.refreshPanelHubData();
        break;

      case PanelHubEventType.PaginationChanged:
        this.currentPagination = event.state.pagination || null;
        this.refreshPanelHubData();
        break;
    }
  }

onPanelViewChanged(view: number) {
  this.currentView = view;
  this.panelCardViewType = view;
  this.resetPanelHubState();// reset filters, sort, pagination
  this.baseFilters = this.buildBaseFiltersFromAdvancedSearch(); // reset search data 
  this.hasUserSearched = true;
  this.panelFilters = {};
  this.panelHubConfig.filterConfigs = this.buildFilterConfigs(view);
  this.panelHubConfig.sortOptions = this.buildSortOptions(view);
  this.persistence.updatePanelListView(view);
  this.updatePanelHubConfigForCurrentView();

  const searchText = this.primarySearchText || '';
  this.preserveSearchData = true;
  this.getAdvancedSearchResults([], searchText).subscribe();
}




  /* Setting up PANEL HUB CONFIG */

 private updatePanelHubConfigForCurrentView() {
  const view = this.panelCardViewType; // current view
  this.panelHubConfig = {
    ...this.panelHubConfig,
    filterConfigs: this.buildFilterConfigs(view),
    sortOptions: this.buildSortOptions(view)
  };
  this.cdr.detectChanges();
}


  
  private buildFilterConfigs(view: number): FilterConfig[] {
  if (view === this.assignmentView) {
    // Filters for assignment view
    return [
      {
        displayName: 'Phase',
        fieldName: 'phaseName',
        options: this.lookupData?.phases || []
      },
      {
        displayName: 'Implementation Owner(s)',
        fieldName: 'implementationOwnersInformation',
        options: this.userList || []
      },
      {
        displayName: 'Collaborator(s)',
        fieldName: 'collaboratorsInformation',
        options: this.userList || []
      },
      {
        displayName: 'Reviewer(s)',
        fieldName: 'reviewersInformation',
        options: this.userList || []
      },
      {
        displayName: 'Approver(s)',
        fieldName: 'approversInformation',
        options: this.userList || []
      },
      {
        displayName: 'Verifier(s)',
        fieldName: 'verifiersInformation',
        options: this.userList || []
      },
      {
        displayName: 'Internal Client Contact',
        fieldName: 'internalClientContactInformation',
        options: this.userList || []
      }
    ];
  } else {
    // Filters for default view
    return [
      {
        displayName: 'Phase',
        fieldName: 'phaseName',
        options: this.lookupData?.phases || []
      },
      {
        displayName: 'Category',
        fieldName: 'categoryName',
        options: this.lookupData?.categories || []
      },
      {
        displayName: 'Priority',
        fieldName: 'priorityName',
        options: this.lookupData?.priorities || []
      },
        {
        displayName: 'Implementation Owner(s)',
        fieldName: 'implementationOwnersInformation',
        options: this.userList || []
      },
      {
        displayName: 'Responsible Sub-BU',
        fieldName: 'responsibleSubBU',
        options: this.sbuList || []
      },
      {
        displayName: 'eQMS Scope(s)',
        fieldName: 'eQMSScopeDisplayNames',
        options: this.scopeList || []
      }
    ];
  }
}

private buildSortOptions(view: number): SortField[] {
  if (view === this.assignmentView) {
    return [
      { fieldDisplayName: 'Implementation Owner(s)', fieldName: 'implementationOwnersInformation' },
      { fieldDisplayName: 'Collaborator(s)', fieldName: 'collaboratorsInformation' },
      { fieldDisplayName: 'Reviewer(s)', fieldName: 'reviewersInformation' },
      { fieldDisplayName: 'Approver(s)', fieldName: 'approversInformation' },
      { fieldDisplayName: 'Verifier(s)', fieldName: 'verifiersInformation' },
      { fieldDisplayName: 'Internal Client Contact', fieldName: 'internalClientContactInformation' }
    ];
  } else {
    return [
      { fieldDisplayName: 'Phase', fieldName: 'phaseName' },
      { fieldDisplayName: 'Category', fieldName: 'categoryName' },
      { fieldDisplayName: 'Priority', fieldName: 'priorityName' },
      { fieldDisplayName: 'Responsible Sub-BU', fieldName: 'responsibleSubBU' },
      { fieldDisplayName: 'eQMS Scope(s)', fieldName: 'eQMSScopeDisplayNames' },
      { fieldDisplayName: 'Implementation Owner(s)', fieldName: 'implementationOwnersInformation' }
    ];
  }
}


  private updateeQMSScopeData(data: any[]): Observable<any[]> {
    return this.eqmsScopeService.geteQMSScopeLookup().pipe(
      map(scopes => {
        const scopeMap = new Map(
          scopes.map((s: any) => [s.eQMSScopeId, s.eQMSScopeName])
        );
        data.forEach(d => {
          d.eQMSScopeDisplayNames =
            (d.eQMSScope || []).map((id: number) =>
              scopeMap.get(id)
            );
        });
        return data;
      })
    );
  }

  private updateSearchResult(
    data: ChangeControlSearchResult[],
    total: number
  ) {
    this.changeControlSearchResult = data;
    this.pagedData = {
      data,
      totalRecords: total,
      pageNumber: this.currentPagination?.pageNumber ?? 1,
      pageSize: this.currentPagination?.pageSize ?? 0
    };

    this.noData = data.length === 0;
    this.isPanelHubDataAvailable = true;
    this.spinnerOn = false;

    //Reset the scroll of the panel card data on filter change and panel reload
     setTimeout(() => {
    const panelList = this.panelHubEl?.nativeElement.querySelector('.panel-list-content');
    if (panelList) {
      panelList.scrollTop = 0;
    }
  });
  }

  /*Merging filters */

  private buildBaseFilters(filters: Array<any>) {
    if (!filters || filters.length === 0) {
      this.baseFilters = null;
      return;
    }

    // Exclude date fields from base filters as they're handled separately in changeControlSearchData
    const nonDateFilters = filters.filter(f => f.columnName !== 'targetCompletionDate');
    
    if (nonDateFilters.length === 0) {
      this.baseFilters = null;
      return;
    }

    this.baseFilters = {
      filters: nonDateFilters.map(f => ({
        field: f.columnName,
        values: f.values
      })),
      searchText: this.primarySearchText || undefined
    };
  }

private mergeFilters(
  baseFilters: AppliedFilters | null,
  panelHubFilters: AppliedFilters | null
): AppliedFilters | null {
  if (!panelHubFilters) return null;

  return {
    filters: panelHubFilters.filters
      ? panelHubFilters.filters.map(filter => ({
          ...filter,
          values: [...filter.values]
        }))
      : [],
    searchText: panelHubFilters.searchText
  };
}



  /* Utility Methods */


  private areAllValuesNullOrUndefined(data: any): boolean {
    return Object.values(data).every(
      v =>
        v === undefined ||
        v === null ||
        (Array.isArray(v) && v.length === 0) ||
        (typeof v === 'string' && v.trim().length === 0)
    );
  }

  openChangeControl(changeControlNumber: string) {
    const url = location.origin.concat(
      '/eqms.changeControlDetails/',
      changeControlNumber
    );
    window.open(url, '_blank');
  }

  calculatePhaseColor(phase: string): string {
    switch (phase) {
      case '0':
        return 'in_collaboration';
      case '1':
        return 'in_review';
      case '2':
        return 'in_ReadyForApproval';
      case '3':
        return 'in_Implementation';
      case '4':
        return 'in_Verification';
      case '5':
        return 'in_Complete';
        case '6':
          return 'in_Voided';
      default:
        return '';
    }
  }

displayPhaseLabelWithDate(
  phase: string,
  completionDate: Date,
  targetCompletionDate: Date,
  phaseName: string
): string {

  switch (phase) {

    case ChangeRegisterConstants.COMPLETED_PHASE:
      return completionDate
        ? `${phaseName} (${this.datePipe.transform(
            completionDate,
            'dd-MMM-yyyy'
          )})`
        : phaseName;

    case ChangeRegisterConstants.VOIDED_PHASE: // If the status is void no need to display any dates
      return phaseName;

    default:
      return targetCompletionDate
        ? `${phaseName} (${this.datePipe.transform(
            targetCompletionDate,
            'dd-MMM-yyyy'
          )})`
        : phaseName;
  }
}

}
